'use client';

import { motion } from 'motion/react';

interface BlinkingIndicatorProps {
  color?: string;
  size?: number;
  duration?: number;
  className?: string;
  style?: React.CSSProperties;
}

const BlinkingIndicator = ({
  color = 'var(--color-red-600)',
  size = 10,
  duration = 1,
  className,
  style,
}: BlinkingIndicatorProps) => {
  return (
    <>
      <motion.div
        className={className}
        style={{ ...style, width: size, height: size, backgroundColor: color, borderRadius: '50%' }}
        animate={{ opacity: [0, 1] }}
        transition={{
          duration: duration,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      />
    </>
  );
};

export default BlinkingIndicator;